import { render } from "./tours-scr.vue?vue&type=template&id=3cb7f495&scoped=true"
import script from "./tours-scr.vue?vue&type=script&lang=js"
export * from "./tours-scr.vue?vue&type=script&lang=js"

import "./tours-scr.vue?vue&type=style&index=0&id=3cb7f495&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb7f495"]])

export default __exports__